import React from 'react';
import ErrorMessage, { Error } from './ErrorMessage';
import Button from '../../../../../common/components/Button';

const EnquireForm = props => {
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    onCancel,
  } = props;

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-12">
          <label className="control-label">From</label>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="firstName"
              className="form-control"
              placeholder="First name *"
              value={values.firstName}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <ErrorMessage errors={errors} touched={touched} name="firstName" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="lastName"
              className="form-control"
              placeholder="Surname *"
              value={values.lastName}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <ErrorMessage errors={errors} touched={touched} name="lastName" />
          </div>
        </div>
      </div>

      <div className="form-group">
        <input
          type="text"
          name="email"
          className="form-control"
          placeholder="Enter your e-mail *"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <ErrorMessage errors={errors} touched={touched} name="email" />
      </div>

      <div className="form-group">
        <input
          type="text"
          name="phone"
          className="form-control"
          placeholder="Enter your phone number *"
          value={values.phone}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <ErrorMessage errors={errors} touched={touched} name="phone" />
      </div>

      <div className="form-group">
        <input
          type="text"
          name="address"
          className="form-control"
          placeholder="Enter your address"
          value={values.address}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <ErrorMessage errors={errors} touched={touched} name="address" />
      </div>

      <div className="form-group">
        <label className="control-label">Message</label>
        <textarea
          className="form-control"
          name="message"
          placeholder="Enter your message here *"
          value={values.message}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <ErrorMessage errors={errors} touched={touched} name="message" />
      </div>

      {errors.general && (
        <div className="form-group">
          <Error text={errors.general} />
        </div>
      )}

      <br />
      <div className="row">
        <div className="col-md-4">
          <div className="form-group">
            <div className="form-required-message">* Mandatory fields</div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <Button
              type="button"
              className="-block -empty"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <Button type="submit" className=" -block" disabled={isSubmitting}>
              {isSubmitting ? 'Please, wait...' : 'Send'}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EnquireForm;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/parts/EnquireForm/EnquireForm.js